import env from "../../utils/helpers/functions/env";
import { SolarEyeScanBoldDuotone } from "../icons/SolarEyeScanBoldDuotone"

const PreviewSiteButton = () => {
    return (
        <div className="pc-h-item ">
            <a className="pc-head-link ms-0 cursor-pointer"
                target="_blank"
                href={env('REACT_APP_PREVIEW')}>
                <SolarEyeScanBoldDuotone/>
            </a>
        </div>
    )
}

export default PreviewSiteButton;